import { render, staticRenderFns } from "./ClassifiedCard.vue?vue&type=template&id=d7489ce6&scoped=true&lang=pug"
import script from "./ClassifiedCard.vue?vue&type=script&lang=js"
export * from "./ClassifiedCard.vue?vue&type=script&lang=js"
import style0 from "./ClassifiedCard.vue?vue&type=style&index=0&id=d7489ce6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7489ce6",
  null
  
)

export default component.exports